export const ORDER_HUB_URL = "/orderhub";
